import { createFileRoute } from "@tanstack/react-router";
import { InsufficientPermissionsPage } from "src/components/views/login/InsufficientPermissionsPage.tsx";

export const Route = createFileRoute("/insufficientPermissions")({
	component: InsufficientPermissionsPage,
});
